// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"485":"3f45ec47d66e1f84","3305":"a266981e922326ad","7796":"e35334a2a5b2ef5d"}[chunkId] + ".css";
};